import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowedRoles = route.data['allowedRoles'];
    const user = localStorage.getItem('user');
    const userRole = user ? JSON.parse(user).accessType : null;

    if (allowedRoles.includes(userRole) || (userRole === 4 &&
      allowedRoles.includes(0))) {
      return true; // Allow navigation for allowed roles
    } else if (userRole && [1, 2, 3].includes(userRole)) {
      this.router.navigate(['/dashboard']); // Redirect non-admins to placeholder
      return false;
    } else {
      this.router.navigate(['/unauthorized']); // Unauthorized access
      return false;
    }
  }
}
